import { render, staticRenderFns } from "./PhoneNumberInput.vue?vue&type=template&id=4a2dd0e9&scoped=true&"
import script from "./PhoneNumberInput.vue?vue&type=script&lang=js&"
export * from "./PhoneNumberInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2dd0e9",
  null
  
)

export default component.exports